




import { Vue, Component, Prop } from 'vue-property-decorator';
import { Chart } from 'highcharts-vue';

@Component({
  components: {
    highcharts: Chart,
  },
})
export default class DownlineChart extends Vue {
  @Prop() readonly series: any;

  @Prop() readonly title!: string;

  chartOptions: any = {
    tooltip: {
      useHTML: true,
      headerFormat: '',
      pointFormat: '<span style="color:{point.color}">●</span><b>{point.name} <b><br>{point.y:,.0f}',
    },
    chart: {
      type: 'pie',
    },
    title: {
      text: this.title,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.y}',
        },
      },
    },
  };

  created() {
    const { series } = this;
    this.chartOptions = { ...this.chartOptions, series };
  }
}
